<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createPhase') }}</h1>
      <div class="form-container">
        <PhaseForm @save="save"></PhaseForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import PhaseForm from '@/components/PhaseForm'

  export default {
    components: {
      DashboardLayout,
      PhaseForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Phase/create', {
          phase: form,
          projectId: this.$route.params.projectId
        }).then(() => {
          this.$router.push({
            name: 'projectDetail',
            params: {
              projectId: this.$route.params.projectId,
              section: 'phases'
            }
          })
        })
      }
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'projects', path: 'projects'},
          {
            name: 'projectDetail',
            path: {
              name: 'projectDetail',
              params: {projectId: this.$route.params.projectId}
            }
          },
          {name: 'createPhase'}
        ]
      }
    }
  }
</script>
